<template>
  <div class="headers">
    <img class="logo" src="@/images/logo.png" alt="logo" />
    <div class="category">
      <div v-for="(item,i) in category" :key="i">
        <router-link
          :class="$route.path===item.url?'curr':null"
          :to="item.url"
          v-if="item.sub.length==0"
        >{{item.zh.name}}</router-link>
        <Dropdown v-if="item.sub.length>0" @command="handleCommand">
          <a href="javascript:;">{{item.zh.name}}</a>
          <DropdownMenu slot="dropdown">
            <DropdownItem
              v-for="(sub,j) in item.sub"
              :key="j"
              :disabled="sub.url==='#'"
              :command="sub.url"
            >{{sub.zh.name}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="contact">
        <!-- <img class="icon" src="@/images/icon_contact.png" alt="icon" /> -->
        <i class="el-icon-headset" />
        <span>{{contact}}</span>
      </div>
      <router-link to="/login" v-show="!isLogin">
        <i class="el-icon-user" style="font-size: 16px;" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

export default {
  name: 'headers',
  props: {
    category: Array,
    contact: String,
  },
  components: { Dropdown, DropdownMenu, DropdownItem },
  data() {
    return {
      isLogin: false,
    }
  },
  mounted() {
    let authority = sessionStorage.getItem('authority')
    this.isLogin = Boolean(authority === 'admin')
  },
  methods: {
    handleCommand(command) {
      this.$router.push(command)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>
